<div class="SLV2-start-test-popup">
    <div class="SLV2-text-radio-group">
        <label class="SLV2-text-radio">
            <input type="radio" name="testname" checked /><span>Half chapter test</span>
        </label>
        <label class="SLV2-text-radio">
            <input type="radio" name="testname" /><span>Full chapter test</span>
        </label>
    </div>
    <div class="SLV2-popup-content-area">
        <div class="SLV2-pop-datainfo">
            <label>Chapter name</label>
            <ul class="SLV2-pop-datainfo-list">
                <li>Chapter name</li>
            </ul>
        </div>
        <div class="SLV2-pop-datainfo">
            <label>Topic names</label>
            <ul class="SLV2-pop-datainfo-list">
                <li>Topic name</li>
                <li>Topic name</li>
                <li>Topic name</li>
            </ul>
        </div>
        <div class="SLV2-pop-datainfo">
            <label>Number of Questions</label>
            <ul class="SLV2-pop-datainfo-list">
                <li>20</li>
            </ul>
        </div>
        <div class="SLV2-pop-datainfo">
            <label>Time allotted to complete the test</label>
            <ul class="SLV2-pop-datainfo-list">
                <li>30 mins</li>
            </ul>
        </div>
    </div>
    <div class="SLV2-popup-actn-area">
        <button class="SLV2-popup-text-btn mr-5" (click)="close()">Back</button>
        <button class="SLV2-popup-solid-btn" (click)="startTest()">Start Test</button>
    </div>
</div>
